import * as api from './api'

export default {
  async healthCheck ({ commit }) {
    const { data } = await api.healthCheck() || {}

    if (data?.code === 200) {
      commit('setIsOffline', false)

      return { data: data.data }
    }

    return { error: data.data }
  },
  resetLocalStore ({ commit }) {
    const CLEAR_DATA_MODULES = [
      'category',
      'product',
      'onlineOrder',
      'user',
      'users',
      'settings',
      'sale',
      'workingShift',
      'cashOperation',
      'history',
      'repair'
    ]

    for (let i = 0; i < CLEAR_DATA_MODULES.length; i++) {
      const module = CLEAR_DATA_MODULES[i]

      commit(`${module}/clearState`, {}, { root: true })
    }
  }
}